import Link from "next/link";

type PersonalDataConsentProps = {
  className?: string;
  name?: string;
  required?: boolean;
};

export function PersonalDataConsent({
  className = "",
  name = "personalDataConsent",
  required = true
}: PersonalDataConsentProps) {
  return (
    <label className={`privacy-consent ${className}`.trim()}>
      <input name={name} required={required} type="checkbox" value="1" />
      <span>
        Я согласен на обработку персональных данных для оформления заказа, заявки,
        обратной связи и доставки в соответствии с{" "}
        <Link href="/privacy" target="_blank">
          политикой обработки персональных данных
        </Link>
        .
      </span>
    </label>
  );
}
